import React from "react";

// Bộ icon nét mảnh dùng chung cho toàn trang (SVG nội tuyến, lấy màu theo
// `currentColor` nên tự đổi màu theo chữ của nút chứa nó).
const Svg = ({ size = 18, strokeWidth = 1.8, children, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
    {...rest}
  >
    {children}
  </svg>
);

export const IcoHome = (p) => (
  <Svg {...p}>
    <path d="M3 10.6 12 3l9 7.6" />
    <path d="M5 9.2V20a1 1 0 0 0 1 1h3.5v-6h5v6H18a1 1 0 0 0 1-1V9.2" />
  </Svg>
);

export const IcoFolder = (p) => (
  <Svg {...p}>
    <path d="M3 7a2 2 0 0 1 2-2h4.2a2 2 0 0 1 1.5.7L12 7h7a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
  </Svg>
);

export const IcoFolderPlus = (p) => (
  <Svg {...p}>
    <path d="M3 7a2 2 0 0 1 2-2h4.2a2 2 0 0 1 1.5.7L12 7h7a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    <path d="M12 10.5v5M9.5 13h5" />
  </Svg>
);

export const IcoFolderUp = (p) => (
  <Svg {...p}>
    <path d="M3 7a2 2 0 0 1 2-2h4.2a2 2 0 0 1 1.5.7L12 7h7a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    <path d="M12 16v-5M9.6 13.2 12 10.8l2.4 2.4" />
  </Svg>
);

export const IcoUpload = (p) => (
  <Svg {...p}>
    <path d="M4 15.5V18a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2.5" />
    <path d="M12 15V4M7.5 8.5 12 4l4.5 4.5" />
  </Svg>
);

export const IcoDownload = (p) => (
  <Svg {...p}>
    <path d="M4 15.5V18a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2.5" />
    <path d="M12 4v11M7.5 10.5 12 15l4.5-4.5" />
  </Svg>
);

export const IcoCloudUp = (p) => (
  <Svg {...p}>
    <path d="M7 18.5a4.5 4.5 0 0 1-.6-8.96A6 6 0 0 1 18 8.6a4.6 4.6 0 0 1-.6 9.9" />
    <path d="M12 20v-8M8.8 14.8 12 11.6l3.2 3.2" />
  </Svg>
);

export const IcoCompress = (p) => (
  <Svg {...p}>
    <path d="M4 14h6v6M20 10h-6V4" />
    <path d="M14 10l6.5-6.5M3.5 20.5 10 14" />
  </Svg>
);

export const IcoTrash = (p) => (
  <Svg {...p}>
    <path d="M4 7h16" />
    <path d="M18.5 7 17.6 19a2 2 0 0 1-2 1.9H8.4a2 2 0 0 1-2-1.9L5.5 7" />
    <path d="M9.5 7V4.8a.8.8 0 0 1 .8-.8h3.4a.8.8 0 0 1 .8.8V7" />
    <path d="M10 11v6M14 11v6" />
  </Svg>
);

export const IcoRestore = (p) => (
  <Svg {...p}>
    <path d="M4 5v5h5" />
    <path d="M4.6 10A8 8 0 1 1 6 16.9" />
  </Svg>
);

export const IcoCopy = (p) => (
  <Svg {...p}>
    <rect x="9" y="9" width="11.5" height="11.5" rx="2.2" />
    <path d="M5.5 15H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v.5" />
  </Svg>
);

export const IcoLink = (p) => (
  <Svg {...p}>
    <path d="M10 14a4.2 4.2 0 0 0 6 0l3.2-3.2a4.2 4.2 0 0 0-6-6L12 6" />
    <path d="M14 10a4.2 4.2 0 0 0-6 0l-3.2 3.2a4.2 4.2 0 0 0 6 6L12 18" />
  </Svg>
);

export const IcoCheck = (p) => (
  <Svg {...p}>
    <path d="M5 12.5 10 17.5 19.5 7" />
  </Svg>
);

export const IcoPencil = (p) => (
  <Svg {...p}>
    <path d="M4 20h4.2L19.3 8.9a2 2 0 0 0 0-2.8l-1.4-1.4a2 2 0 0 0-2.8 0L4 15.8z" />
    <path d="M13.5 6.5 17.5 10.5" />
  </Svg>
);

export const IcoEye = (p) => (
  <Svg {...p}>
    <path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z" />
    <circle cx="12" cy="12" r="3" />
  </Svg>
);

export const IcoSearch = (p) => (
  <Svg {...p}>
    <circle cx="11" cy="11" r="7" />
    <path d="m20.5 20.5-4.4-4.4" />
  </Svg>
);

export const IcoX = (p) => (
  <Svg {...p}>
    <path d="M6 6l12 12M18 6 6 18" />
  </Svg>
);

export const IcoChevronRight = (p) => (
  <Svg {...p}>
    <path d="m9 5 7 7-7 7" />
  </Svg>
);

export const IcoChevronLeft = (p) => (
  <Svg {...p}>
    <path d="m15 5-7 7 7 7" />
  </Svg>
);

export const IcoArrowLeft = (p) => (
  <Svg {...p}>
    <path d="M20 12H4M10 6l-6 6 6 6" />
  </Svg>
);

export const IcoMenu = (p) => (
  <Svg {...p}>
    <path d="M4 7h16M4 12h16M4 17h16" />
  </Svg>
);

export const IcoLogOut = (p) => (
  <Svg {...p}>
    <path d="M9.5 20H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h3.5" />
    <path d="M15.5 16.5 20 12l-4.5-4.5M20 12H9.5" />
  </Svg>
);

export const IcoImage = (p) => (
  <Svg {...p}>
    <rect x="3" y="4" width="18" height="16" rx="2.5" />
    <circle cx="8.5" cy="9.5" r="1.6" />
    <path d="m21 15.5-4.6-4.6a1 1 0 0 0-1.4 0L6 20" />
  </Svg>
);

export const IcoFilm = (p) => (
  <Svg {...p}>
    <rect x="3" y="4" width="18" height="16" rx="2.5" />
    <path d="m10 9 5 3-5 3z" />
  </Svg>
);

export const IcoFileText = (p) => (
  <Svg {...p}>
    <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
    <path d="M14 3v5h5M9 13h6M9 17h4" />
  </Svg>
);

export const IcoGlobe = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" />
  </Svg>
);

export const IcoAlert = (p) => (
  <Svg {...p}>
    <path d="M10.3 4.2 2.6 17.5A2 2 0 0 0 4.3 20.5h15.4a2 2 0 0 0 1.7-3L13.7 4.2a2 2 0 0 0-3.4 0z" />
    <path d="M12 9.5v4.2M12 17h.01" />
  </Svg>
);

export const IcoInfo = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 11v5.5M12 7.6h.01" />
  </Svg>
);

export const IcoCheckCircle = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="m8 12.3 2.7 2.7L16 9.6" />
  </Svg>
);

export const IcoExternal = (p) => (
  <Svg {...p}>
    <path d="M13 5h6v6M19 5l-8.5 8.5" />
    <path d="M18 14v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4" />
  </Svg>
);

export const IcoSort = (p) => (
  <Svg {...p}>
    <path d="M7 5v14M3.5 15.5 7 19l3.5-3.5M13 7h8M13 12h6M13 17h4" />
  </Svg>
);

export const IcoLock = (p) => (
  <Svg {...p}>
    <rect x="4.5" y="10.5" width="15" height="10" rx="2.2" />
    <path d="M8 10.5V7.8a4 4 0 0 1 8 0v2.7" />
  </Svg>
);

export const IcoUnlock = (p) => (
  <Svg {...p}>
    <rect x="4.5" y="10.5" width="15" height="10" rx="2.2" />
    <path d="M8 10.5V7.8a4 4 0 0 1 7.6-1.7" />
  </Svg>
);

export const IcoKey = (p) => (
  <Svg {...p}>
    <circle cx="8" cy="15" r="4.2" />
    <path d="m11.2 12 8.3-8.3" />
    <path d="m16.5 6.7 2.6 2.6" />
    <path d="m14 9.2 2 2" />
  </Svg>
);

export const IcoEyeOff = (p) => (
  <Svg {...p}>
    <path d="M9.9 5.2A9.6 9.6 0 0 1 12 5c6 0 9.5 7 9.5 7a15.6 15.6 0 0 1-2.6 3.5" />
    <path d="M6.3 6.8A15.3 15.3 0 0 0 2.5 12S6 19 12 19a9.3 9.3 0 0 0 4.6-1.2" />
    <path d="M9.9 9.9a3 3 0 0 0 4.2 4.2" />
    <path d="m3.5 3.5 17 17" />
  </Svg>
);

export const IcoUser = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="8" r="4" />
    <path d="M4.5 20.5a7.5 7.5 0 0 1 15 0" />
  </Svg>
);

export const IcoPlay = (p) => (
  <Svg {...p}>
    <path d="M8 5.5v13l11-6.5z" fill="currentColor" />
  </Svg>
);

// Icon thư mục hai tông màu cho các ô thư mục (không dùng ảnh PNG nữa).
export const FolderGlyph = ({ size = 40 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" aria-hidden="true" focusable="false">
    <path
      d="M5 13.5A4.5 4.5 0 0 1 9.5 9h9.1a4.5 4.5 0 0 1 3.4 1.55L24.6 13.5H38.5A4.5 4.5 0 0 1 43 18v2H5z"
      fill="var(--folder-back, #5AAEE6)"
    />
    <path
      d="M5 19.5A3.5 3.5 0 0 1 8.5 16h31A3.5 3.5 0 0 1 43 19.5v15A4.5 4.5 0 0 1 38.5 39h-29A4.5 4.5 0 0 1 5 34.5z"
      fill="var(--folder-front, #1D8AD6)"
    />
    <path d="M11 22.5h12" stroke="rgba(255,255,255,.55)" strokeWidth="2.2" strokeLinecap="round" fill="none" />
  </svg>
);
